import Styles from "./styles.module.css";
import React from 'react';
import Stores from "src/pages/recruit/recruit/2.stores";
import { RxCross2 } from "react-icons/rx";

type RecruitPageStoresProps = {
  companyId: string;
  setToggle: React.Dispatch<React.SetStateAction<any>>;
  searchPref: string;
  searchType: string;
};

const RecruitPageStores: React.FC<RecruitPageStoresProps> = ({ companyId, setToggle, searchPref, searchType }) => {

  return (
    <>
    <div className={Styles.modal}>
      <div className={Styles.background_black} onClick={() => setToggle({ type: "",  id: "", name: "" })}></div>
      <div className={Styles.contents}>
        <div className={Styles.modal_title}>
          <h4>店舗情報</h4>
          <RxCross2 className={Styles.modal_cross} onClick={() => setToggle({ type: "",  id: "", name: "" })} />
        </div>
        <div className={Styles.contents_store}>
          <Stores companyId={companyId} searchPref={searchPref} searchType={searchType} />
        </div>
      </div>
    </div>
    </>
  );
}

export default RecruitPageStores;
